import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RedirectToError = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/error", { replace: true });
  }, [navigate]);

  return null;
};

export default RedirectToError;
